import { useId, forwardRef, HTMLProps } from "react";
import { cn } from "@/utils/helpers";
import styles from "../Field.module.css";

const FieldInput = forwardRef<HTMLInputElement, HTMLProps<HTMLInputElement>>(({
	name,
	type = "text",
	placeholder,
	autoComplete = "off",
	autoCapitalize = "off",
	autoCorrect = "off",
	className,
    ...props
}, ref) => {
	const id = useId();
	return (
		<input
			ref={ref}
			id={id}
			className={cn(styles.FieldInput, className)}
			type={type}
			name={name}
			placeholder={placeholder}
			autoComplete={autoComplete}
			autoCapitalize={autoCapitalize}
			autoCorrect={autoCorrect}
			{...props}
		/>
	)
});

export default FieldInput;